import { useToast, UseToastOptions } from '@chakra-ui/react';
import { copyText } from '@pelicargo/ui';

type UseCopyToClipboardOptions = {
  title?: string;
  duration?: number;
  toastOptions?: UseToastOptions;
};

export const useCopyToClipboard = (defaultOptions?: UseCopyToClipboardOptions) => {
  const toast = useToast();

  const handleCopy = (text?: string | null, options?: UseCopyToClipboardOptions) => async () => {
    if (!text) return;

    try {
      await copyText(text);

      toast({
        title: options?.title ?? defaultOptions?.title ?? 'Link Copied',
        description: text,
        status: 'success',
        duration: options?.duration ?? defaultOptions?.duration ?? 3000,
        isClosable: true,
        ...defaultOptions?.toastOptions,
        ...options?.toastOptions,
      });
    } catch (error: any) {
      toast({
        title: 'Error',
        description: error?.message ?? 'Failed to copy text',
        status: 'error',
        duration: 10000,
        isClosable: true,
      });
    }
  };

  return handleCopy;
};
